import store from 'store';
import actions from 'store/actions/vehicle';

export const getVehicle = async (id) => {
  return actions.getVehicle(id);
};

export const getVehicleGroups = async (queryString) => {
  return actions.getVehicleGroups(queryString);
};

export const getVehicleModels = async () => {
  return actions.getVehicleModels();
};

export const editVehicle = async (data, id) => {
  return actions.editVehicle(data, id);
};

export const editVehicleGroups = async (data) => {
  return actions.editVehicleGroups(data);
};

export const addVehicle = async (data) => {
  return actions.addVehicle(data);
};

export const addVehicleGroups = async (data) => {
  return actions.addVehicleGroups(data);
};

export const changeVehicleGroupStatus = async (data) => {
  return actions.changeVehicleGroupStatus(data);
};

export const deleteVehicle = async (id) => {
  return actions.deleteVehicle(id);
};

export const deleteVehicleGroups = async (id) => {
  return actions.deleteVehicleGroups(id);
};

export const changeVehicleStatus = async (payload) => {
  return actions.changeVehicleStatus(payload);
};

export const updateCourierApplicationStatus = async (payload, id) => {
  return actions.updateCourierApplicationStatus(payload, id);
};
